import React from 'react';
import { FILTER_COLLATION, FILTER_OPERATION, ModelRenderer } from '@veeam/core';
import { DatePeriod } from "../../controls";
export function toolbarDatePeriodFilter(_a) {
    var startProperty = _a.startProperty, endProperty = _a.endProperty, _b = _a.groupId, groupId = _b === void 0 ? '' : _b, disabled = _a.disabled, decorators = _a.decorators, texts = _a.texts, startDatetime = _a.startDatetime, endDatetime = _a.endDatetime;
    return {
        decorators: decorators,
        disabled: disabled,
        render: function (model, _a) {
            var disabled = _a.disabled;
            return (React.createElement(ModelRenderer, { model: model, render: function (_a) {
                    var filters = _a.value.filters;
                    var startFilterValue = filters.getFilterValue({
                        property: startProperty,
                        groupId: groupId
                    });
                    var endFilterValue = filters.getFilterValue({
                        property: endProperty,
                        groupId: groupId
                    });
                    var value = startFilterValue && endFilterValue
                        ? [
                            new Date(startFilterValue),
                            new Date(endFilterValue)
                        ]
                        : [];
                    return (React.createElement(DatePeriod, { value: value, texts: texts, startDatetime: startDatetime, endDatetime: endDatetime, disabled: disabled, onChange: function (value) {
                            if (!value.length) {
                                model.setFilter({ property: startProperty, groupId: groupId }, null);
                                model.setFilter({ property: endProperty, groupId: groupId }, null);
                                return;
                            }
                            var start = value[0];
                            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                            var end = new Date(value[1] || value[0]);
                            end.setHours(24, 0, 0, 0);
                            end = new Date(end.valueOf() - 1);
                            model.setFilter({ property: startProperty, groupId: groupId }, {
                                value: start.toISOString(),
                                operation: FILTER_OPERATION.greaterThanOrEqual,
                                collation: FILTER_COLLATION.ignorecase
                            });
                            model.setFilter({ property: endProperty, groupId: groupId }, {
                                value: end.toISOString(),
                                operation: FILTER_OPERATION.lessThanOrEqual,
                                collation: FILTER_COLLATION.ignorecase
                            });
                        } }));
                } }));
        }
    };
}
//# sourceMappingURL=toolbarDatePeriodFilter.js.map